module.exports = __webpack_public_path__ + "img/forvestch.c0325cf4.png";